import type { ManifestRouteDefinition, ManifestSubFeature } from '@/core/manifest/types'
import { collectManifestPathByKey } from '@/core/manifest/paths'
import { commonManifestRoutes } from '@/features/common/common.manifest'
import { dashboardManifestRoutes } from '@/features/dashboard/dashboard.manifest'
import { appearanceRouteRoot } from '@/features/appearence/appearance.manifest'
import { moduleFeatureConfigRouteRoot } from '@/features/moduleFeatureConfig/moduleFeatureConfig.manifest'
import { roleRouteRoot } from '@/features/role/role.manifest'
import { settingsManifestRoutes } from '@/features/settings/settings.manifest'
import { supportManifestRoutes } from '@/features/support/support.manifest'
import { usersRouteRoot } from '@/features/users/users.manifest'
import { adpManifestRoutes } from '@/features/adp/adp.manifest'

export const allManifestRouteRoots: ManifestRouteDefinition[] = [
  ...dashboardManifestRoutes,
  usersRouteRoot,
  roleRouteRoot,
  appearanceRouteRoot,
  moduleFeatureConfigRouteRoot,
  ...supportManifestRoutes,
  ...settingsManifestRoutes,
  ...commonManifestRoutes,
  ...adpManifestRoutes,
]

export const manifestRoutePathByKey = collectManifestPathByKey(allManifestRouteRoots)

export type ManifestSubFeatureEntry = ManifestSubFeature & {
  routeKey: string
  path: string
}

/** Optional RBAC helper when routes define `subFeatures` */
export function flattenManifestSubFeatures(): ManifestSubFeatureEntry[] {
  return []
}
